<div class="flex w-full gap-x-2" [class.mb-2]="!last">
  @if (!isImport) {
    <div class="w-3/12" tuiGroup [collapsed]="true">
      <app-autocomplete
        [appCompareWithField]="parentDetails?.cargoPlaceJson?.code"
        label="Грузовое место"
        [labelOutside]="false"
        class="tui-group__inherit-item w-8/12 tui-group__auto-width-item"
        componentClass="tui-group__inherit-item"
        [formControl]="
          cargoPlaceDetailsForm.controls.cargoPlaceJson.controls.code
        "
        [items]="catalogs.cargoPlaces$ | async"
        [itemValue]="'code'"
        [itemText]="'name'"
        [displayValue]="'name'"
        [itemSearch]="'search'"
      ></app-autocomplete>
      <tui-input-number
        [formControl]="cargoPlaceQuantityLimit"
        class="w-4/12 tui-group__auto-width-item"
        tuiTextfieldSize="m"
      ></tui-input-number>
    </div>
  }
  <div class="flex items-center">
    <app-checkbox
      [appCompareWithField]="parentDetails?.box"
      [formControl]="cargoPlaceDetailsForm.controls.box"
      [tuiHint]="box"
    ></app-checkbox>
    <ng-template #box> Коробки</ng-template>
  </div>
  <div class="flex gap-x-2" [class]="isImport ? 'w-8/12' : 'w-5/12'">
    @if (hasBox$ | async) {
      <div class="w-9/12" tuiGroup [collapsed]="true">
        <app-autocomplete
          [appCompareWithField]="parentDetails?.packageTypeJson?.code"
          label="Код"
          class="tui-group__inherit-item w-9/12 tui-group__auto-width-item"
          componentClass="tui-group__inherit-item"
          [labelOutside]="false"
          [formControl]="
            cargoPlaceDetailsForm.controls.packageTypeJson.controls.code
          "
          [items]="preparedPackageTypes$ | async"
          [itemValue]="'code'"
          [itemText]="'itemText'"
          [displayValue]="'itemText'"
          [itemSearch]="'search'"
        ></app-autocomplete>
        <tui-input-number
          [appCompareWithField]="parentDetails?.packageQuantityLimit"
          [formControl]="cargoPlaceDetailsForm.controls.packageQuantityLimit"
          class="w-3/12 tui-group__auto-width-item"
          tuiTextfieldSize="m"
          >Лимит</tui-input-number
        >
      </div>
      <tui-input-number
        [appCompareWithField]="parentDetails?.packageQuantity"
        [precision]="0"
        class="w-2/12"
        tuiTextfieldSize="m"
        [formControl]="cargoPlaceDetailsForm.controls.packageQuantity"
        >Кол-во упаковки</tui-input-number
      >
    }
  </div>

  <tui-input-number
    [appCompareWithField]="parentDetails?.cargoPlaceQuantity"
    tuiTextfieldSize="m"
    [formControl]="cargoPlaceDetailsForm.controls.cargoPlaceQuantity"
    >Кол-во</tui-input-number
  >
  <div class="flex gap-x-2 items-center">
    <button
      [disabled]="!canRemove"
      (click)="remove.emit()"
      appearance="accent"
      tuiIconButton
      icon="tuiIconTrash"
      size="s"
    ></button>
    @if (last) {
      <button
        [disabled]="!canCreate"
        size="s"
        (click)="create.emit()"
        tuiIconButton
        icon="tuiIconPlus"
      ></button>
    }
  </div>
</div>
